const LOCALE_BY_LANGUAGE = {
  ar: "ar-TN",
  en: "en-GB",
  fr: "fr-FR",
  it: "it-IT",
  wo: "fr-SN",
};

const getNotificationLocale = () => {
  const storedLanguage =
    typeof window !== "undefined" ? window.localStorage.getItem("local") : null;
  const language = String(storedLanguage || "fr").split("-")[0].toLowerCase();

  return LOCALE_BY_LANGUAGE[language] || "fr-FR";
};

export const formatNotificationDate = (value) => {
  if (!value) return "";

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  return new Intl.DateTimeFormat(getNotificationLocale(), {
    timeZone: "Africa/Tunis",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
};
